import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import Actions from '@sharedComponent/app-action-reducer/action';
import EmployeeService from 'src/services/employee-service';
import ApproveEmployeeRequestPresentational from './approve-employee-request-presentational';
import 'react-toastify/dist/ReactToastify.css';
import Toast from '@pages/DesignSystem/Toast';
import { EMPLOYEES_PAGE_CONSTANTS } from '@constants/app-constants';

const ApproveEmployeeRequestFunctional = () => {
	const [modalOpen, setModalOpen] = useState(true);
	let [selectedAction, setSelectedAction] = useState('');
	const [modalOpenMobile, setModalOpenMobile] = useState(false);
	let [pendingRequest, setPendingRequest] = useState([]);
	const [isSelectAll, setIsSelectAll] = useState(false);
	const [isSelectedCount, setIsSelectedCount] = useState(0);
	let [isDataLoading, setIsDataLoading] = useState(false);
	let employeeApi = new EmployeeService();
	const dispatch = useDispatch();
	const [visible, setVisible] = useState(false);
	const [isToastVisible, setIsToastVisible] = useState(false);
	const [popupMessage, setPopupMessage] = useState({
		titleMessage: '',
		subMessage: '',
	});
	let [cardType, setCardType] = useState('');

	useEffect(() => {
		getPendingRequest();
	}, []);

	function handleCardAction(index, action) {
		let updatedPendingRequest = [...pendingRequest];
		updatedPendingRequest[index].isSelected = true;
		setPendingRequest(updatedPendingRequest);
		showModal(action);
	}

	// checkbox clicked
	const isSelectClicked = (index) => {
		let updatedPendingRequest = [...pendingRequest];
		updatedPendingRequest[index].isSelected = !updatedPendingRequest[index].isSelected;
		let selectionExist = updatedPendingRequest.filter((request) => request.isSelected);
		if (selectionExist.length > 0) {
			setModalOpen(true);
			setModalOpenMobile(true);
			setIsSelectedCount(selectionExist.length);
		} else {
			setModalOpen(false);
			setModalOpenMobile(true);
			setIsSelectedCount(0);
		}
	};

	// select all(modal checkbox)
	const isSelectedAllClicked = () => {
		let updatedPendingRequest = [...pendingRequest];
		updatedPendingRequest.forEach((request) => {
			request.isSelected = !isSelectAll;
		});
		if (!isSelectAll) {
			setIsSelectedCount(updatedPendingRequest.length);
		} else {
			setIsSelectedCount(0);
		}
		setIsSelectAll(!isSelectAll);
	};

	const showModal = (action) => {
		setVisible(true);
		setModalOpenMobile(false);
		setSelectedAction(action);
	};

	async function handleReview() {
		function titleMessage() {
			const toastText = {
				action:
					selectedAction === EMPLOYEES_PAGE_CONSTANTS.cards.actions.approve
						? 'approved'
						: selectedAction === EMPLOYEES_PAGE_CONSTANTS.cards.actions.reject
							? 'rejected'
							: '',
			};
			if (cardType === EMPLOYEES_PAGE_CONSTANTS.cards.type.all) {
				return `Card request ${toastText.action}!`;
			}
			return `Card ${(cardType || '')?.toLowerCase()} ${toastText.action}!`;
		}
		let payload = getPayload();
		setIsDataLoading(true);
		let reviewedSuccess = await reviewPendingRequest(payload);
		setIsDataLoading(false);
		if (reviewedSuccess) {
			setIsSelectedCount(0);
			setIsToastVisible(true);
			setPopupMessage({
				titleMessage: titleMessage(),
				subMessage: null,
			});
			dispatch(Actions.creators.getPendingStatusStart());
			getPendingRequest();
		}
	}

	async function reviewPendingRequest(payload) {
		try {
			let response = await employeeApi.reviewPendingRequest(payload);
			if (response) {
				return response;
			}
		} catch (err) {
			console.log(err);
		}
	}

	function getPayload() {
		return {
			cardRequestAction: {
				uploadIds: pendingRequest.reduce((acc, request) => {
					if (request.isSelected && request.uploadId && request.cardRequestType === 'Order') {
						acc.push(request.uploadId);
					}
					return acc;
				}, []),
				employeeIds: pendingRequest.reduce((acc, request) => {
					if (request.isSelected && request.employeeId && request.cardRequestType === 'Reissue') {
						acc.push(request.employeeId);
					}
					return acc;
				}, []),
				massCorpDelUploadId: pendingRequest.reduce((acc, request) => {
					if (request.isSelected && request.massCorpDelUploadId && request.cardRequestType === 'Deletion') {
						acc.push(request.massCorpDelUploadId);
					}
					return acc;
				}, []),
				action: selectedAction === 'Approve' ? 'approve' : 'reject',
			},
		};
	}

	const closeModal = () => {
		setVisible(false);
		setCardType('');
		setSelectedAction('');
	};
	const handleApproveOrReject = () => {
		setVisible(false);
		handleReview();
	};

	async function getPendingRequest() {
		setIsDataLoading(true);
		await fetchPendingRequests();
		setIsDataLoading(false);
	}

	async function fetchPendingRequests() {
		try {
			let response = await employeeApi.getPendingRequest();
			if (response && response?.data) {
				let data = response?.data?.requests?.map((response) => {
					response.name = `${response.numberOfRequest}${response?.numberOfRequest > 1 ? ' Cards' : ' Card'} `;
					let orderPlacedDate = moment(response?.orderPlaced);
					response.isSelected = false;
					response['cardRequestType'] = response?.cardRequestType || null;
					response.order = ` ${response['cardRequestType'] === 'Reissue'
						? 'Order Placed'
						: response['cardRequestType'] === 'Deletion'
							? 'Deletion Made'
							: response['cardRequestType'] === 'Order'
								? 'Addition Made'
								: 'Order Placed'
						}: ${orderPlacedDate.format('DD MMMM YYYY')} at ${orderPlacedDate.format('h:mm a')}`;
					response.order2 = ` ${response['cardRequestType'] === 'Reissue'
						? 'Order Placed'
						: response['cardRequestType'] === 'Deletion'
							? 'Deletion Made'
							: response['cardRequestType'] === 'Order'
								? 'Addition Made'
								: 'Order Placed'
						} at ${orderPlacedDate.format('h:mm a')}. ${orderPlacedDate.format('DD MMMM YYYY')}`;
					return response;
				});
				setPendingRequest(data);
			}
		} catch (err) { }
	}

	return (
		<>
			<Toast visible={isToastVisible} clearPopUp={() => setIsToastVisible(false)}>
				{popupMessage.titleMessage}
			</Toast>
			<ApproveEmployeeRequestPresentational
				{...{
					approveRequest: pendingRequest,
					isSelectClicked,
					visible,
					action: selectedAction,
					modalOpenMobile,
					handleApproveOrReject,
					modalOpen,
					loading: isDataLoading,
					showModal,
					closeModal,
					isSelectAll,
					isSelectedAllClicked,
					isSelectedCount,
					handleCardAction,
					selectedAction,
					cardType,
					setCardType,
				}}
			/>
		</>
	);
};
export default ApproveEmployeeRequestFunctional;
